/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import axios from "axios";
import { authHeader } from "_helpers";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSUser from "components/Forms/TSUser"; 
import TSSelect2 from "components/Forms/TSSelect2";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import { Collapse, Modal, ModalBody } from "reactstrap";
import TSSelect from "components/Forms/TSSelect";
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Typography from "@material-ui/core/Typography";
import MailIcon from '@material-ui/icons/Mail';
import Hidden from '@material-ui/core/Hidden';

import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import "./accrued-style.css";
import { time } from "highcharts";
import { blackColor } from "assets/jss/material-dashboard-react";


const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    //maxWidth: 400,
  },
  cardXs: {
      width: 75,
      height: 110,
      paddingTop: 10,
      margin:2,
      textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
      "&:hover": {
          boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
      }
  },
  cardSm: {
    width: 180,
    height: 140,
    textAlign: 'center',
    margin: "3px",
    transition: "0.3s",
    display: "inline-block",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
    }
  },
  cardImg1: {
      width: 60, height: 60, borderRadius: 60 / 2, objectFit: 'cover', objectPosition: '100% 0'
  },
  cardImg2: {
      width: 100, height: 100, borderRadius: 100 / 2, objectFit: 'cover', objectPosition: '100% 0'
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "16px",
    marginTop: "10px",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
});

const LeaveInformation = (props) => {
  var moment = require('moment');
  require('moment/locale/th');
  const [dataList, setDataList] = useState([]);
  const [dataListM1, setDataListM1] = useState([]);
  const [dataListM2, setDataListM2] = useState([]);
  const [dataListM3, setDataListM3] = useState([]);
  const [dataListM4, setDataListM4] = useState([]);
  const [dataListM5, setDataListM5] = useState([]);
  const [dataListM6, setDataListM6] = useState([]);
  const [dataListM7, setDataListM7] = useState([]);
  const [dataListM8, setDataListM8] = useState([]);
  const [dataListM9, setDataListM9] = useState([]);
  const [dataListM10, setDataListM10] = useState([]);
  const [dataListM11, setDataListM11] = useState([]);
  const [dataListM12, setDataListM12] = useState([]);
  const [dataListH, setDataListH] = useState([]);
  const [dataListH2, setDataListH2] = useState([]);
  const [dataListSumYear, setDataListSumYear] = useState([]);
  const [optionYear, setOptionYear] = useState([]);
  const [year, setYear] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [Attendee, setAttendee] = useState([]);
  const [isHR, setIsHR] = useState(false);

  var currentUser = JSON.parse(localStorage.getItem('currentUser'))

  const classes = useStyles();

  const handleAttendee = (_val) => {
      setAttendee(_val);
  };

  useEffect(() => {
    if(Attendee.length != 0){

    setDataListM1([])
    setDataListM2([])
    setDataListM3([])
    setDataListM4([])
    setDataListM5([])
    setDataListM6([])
    setDataListH([])
    setDataListM7([])
    setDataListM8([])
    setDataListM9([])
    setDataListM10([])
    setDataListM11([])
    setDataListM12([])
    setDataListH2([])
    setDataListSumYear([])

    axios.get("/api/LeaveInformationMonth/" + Attendee[0].userName + "/" + year)
    .then(
      result => {
        if(result.data.result == 200)
          {
            setDataListM1(result.data.test[0])
            setDataListM2(result.data.test[1])
            setDataListM3(result.data.test[2])
            setDataListM4(result.data.test[3])
            setDataListM5(result.data.test[4])
            setDataListM6(result.data.test[5])
            setDataListH(result.data.test[6])
            setDataListM7(result.data.test[7])
            setDataListM8(result.data.test[8])
            setDataListM9(result.data.test[9])
            setDataListM10(result.data.test[10])
            setDataListM11(result.data.test[11])
            setDataListM12(result.data.test[12])
            setDataListH2(result.data.test[13])
            setDataListSumYear(result.data.test[14])
          } else {
                  
          }
      }, error => { console.log(error); }
    );  
  }
  }, [Attendee])

  useEffect(() => { 
    axios.get('/api/LeaveInformation')
      .then(
        result => {
          if(result.data.result == 200)
            {
              setDataList(result.data.data)
            } else {
                    
            }
        }, error => { console.log(error); }
      );  

      axios.get("/api/LeaveInformationMonth/" + currentUser.userName + "/" + year)
      .then(
        result => {
          if(result.data.result == 200)
            {
              setDataListM1(result.data.test[0])
              setDataListM2(result.data.test[1])
              setDataListM3(result.data.test[2])
              setDataListM4(result.data.test[3])
              setDataListM5(result.data.test[4])
              setDataListM6(result.data.test[5])
              setDataListH(result.data.test[6])
              setDataListM7(result.data.test[7])
              setDataListM8(result.data.test[8])
              setDataListM9(result.data.test[9])
              setDataListM10(result.data.test[10])
              setDataListM11(result.data.test[11])
              setDataListM12(result.data.test[12])
              setDataListH2(result.data.test[13])
              setDataListSumYear(result.data.test[14])
            } else {
                    
            }
        }, error => { console.log(error); }
      );  

      axios.get("/api/v1/year/")
      .then(
        result => {
          //optionYear.push({ value: 0, label: "กรุณาระบุปีงบประมาณ" });
          result.data.forEach(e => {
            optionYear.push(e);
          });
  
        },
          error => { 
            console.log(error); 
          }
      );
      
      
    axios({
      method: 'post',
      url: "/api/v1/currentdate"
    })
    .then(
       result => {
          var currentUser = JSON.parse(localStorage.getItem('currentUser'))
          const _isHR = currentUser.userDepartment.filter(u => u.departmentKey == 105
            || u.departmentKey == 108
            ).length > 0;
          setIsHR(_isHR);
        },
        error => {console.log(error);}
    );  
  }, [])

  useEffect(() => {
    var user = "";
    if(Attendee.length == 0){
      user = currentUser.userName;
    } else {
      user = Attendee[0].userName;
    }
    setDataListM1([])
    setDataListM2([])
    setDataListM3([])
    setDataListM4([])
    setDataListM5([])
    setDataListM6([])
    setDataListH([])
    setDataListM7([])
    setDataListM8([])
    setDataListM9([])
    setDataListM10([])
    setDataListM11([])
    setDataListM12([])
    setDataListH2([])
    setDataListSumYear([])

    axios.get("/api/LeaveInformationMonth/" + user + "/" + year)
    .then(
      result => {
        if(result.data.result == 200)
          {
            setDataListM1(result.data.test[0])
            setDataListM2(result.data.test[1])
            setDataListM3(result.data.test[2])
            setDataListM4(result.data.test[3])
            setDataListM5(result.data.test[4])
            setDataListM6(result.data.test[5])
            setDataListH(result.data.test[6])
            setDataListM7(result.data.test[7])
            setDataListM8(result.data.test[8])
            setDataListM9(result.data.test[9])
            setDataListM10(result.data.test[10])
            setDataListM11(result.data.test[11])
            setDataListM12(result.data.test[12])
            setDataListH2(result.data.test[13])
            setDataListSumYear(result.data.test[14])
          } else {
                  
          }
      }, error => { console.log(error); }
    );  
  }, [year])


    return (
      <div>
        <Grid>
        {(isHR) && (
        <Col xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>เลือกเจ้าหน้าที่</h4>
              <p className={classes.cardCategoryWhite}>  </p>

            </CardHeader>
            <CardBody>                          
              <Grid>
                <Col xs={12} sm={12} md={12}>
                  <TSUser value={Attendee} isMultiple={false} onChange={e => { handleAttendee(e) } } />
                </Col>
              </Grid>
              </CardBody>
              <CardFooter>
                <Collapse isOpen={isOpen}>

                </Collapse>
              </CardFooter>
            </Card>
          </Col>
          )}

          <Col xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <Grid>       
                  <Col xs={12} sm={12} md={3}>
                    <h4 className={classes.cardTitleWhite}>สถิติการลา</h4>
                  </Col>
                  <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                  <TSSelect
                    options={optionYear}
                    onChange={e => setYear(e)}
                    defaulfAdd={optionYear[0]}
                  />
                  </Col>
                  <Col xs={6} sm={6} md={3} style={{ textAlign: 'right' }}>
                  </Col>
                </Grid>
              </CardHeader>
              <CardBody>
                <Grid>
                  <Col xs={12} sm={12} md={12} >
                  <div style={{overflowX: "scroll"}}>
                    <table>
                      <thead> 
                        <tr>
                        <th style={{
                            textAlign: "center",
                            padding: "0px",
                            columnWidth: "600px",
                            fontSize: "14px",
                            border: "1px solid",
                            minWidth: "125px"
                            }}>
                            เดือน/วันที </th>
                        {dataList.map(({th}) => (
                          <th key={th} style={{
                            textAlign: "center",
                            padding: "0px",
                            columnWidth: "100px",
                            fontSize: "14px",
                            border: "1px solid",
                            minWidth: "25px"
                          }}>{th}</th>
                        ))}
                        <th style={{
                            textAlign: "center",
                            padding: "0px",
                            columnWidth: "100px",
                            fontSize: "14px",
                            border: "1px solid",
                            minWidth: "25px"
                            }}>
                            ป </th>
                        <th style={{
                            textAlign: "center",
                            padding: "0px",
                            columnWidth: "100px",
                            fontSize: "14px",
                            border: "1px solid",
                            minWidth: "25px"
                            }}>
                            ก </th>
                        <th style={{
                            textAlign: "center",
                            padding: "0px",
                            columnWidth: "100px",
                            fontSize: "14px",
                            border: "1px solid",
                            minWidth: "25px"
                            }}>
                            พ </th>
                          <th style={{
                            textAlign: "center",
                            padding: "0px",
                            columnWidth: "100px",
                            fontSize: "14px",
                            border: "1px solid",
                            minWidth: "25px"
                            }}>
                            ข </th>
                          <th style={{
                            textAlign: "center",
                            padding: "0px",
                            columnWidth: "100px",
                            fontSize: "14px",
                            border: "1px solid",
                            minWidth: "25px"
                            }}>
                            ส </th>
                        </tr>
                      </thead>
                      <tbody>
                      <tr>
                        {dataListM1.map(({th, isWeekend, isHoliday, leave}) => (
                          <td key={th} style={ isWeekend ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "yellow"
                          } : isHoliday ? {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid",
                          backgroundColor: "#0DBCBE"
                          } : {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM2.map(({th, isWeekend, isHoliday}) => (
                            <td key={th} style={ isWeekend ? {
                              textAlign: "center",
                              padding: "0px",
                              fontSize: "14px",
                              border: "1px solid",
                              backgroundColor: "yellow"
                            } : isHoliday ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#0DBCBE"
                            } : {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM3.map(({th, isWeekend, isHoliday}) => (
                           <td key={th} style={ isWeekend ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "yellow"
                          } : isHoliday ? {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid",
                          backgroundColor: "#0DBCBE"
                          } : {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM4.map(({th, isWeekend, isHoliday}) => (
                            <td key={th} style={ isWeekend ? {
                              textAlign: "center",
                              padding: "0px",
                              fontSize: "14px",
                              border: "1px solid",
                              backgroundColor: "yellow"
                            } : isHoliday ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#0DBCBE"
                            } : {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM5.map(({th, isWeekend, isHoliday}) => (
                            <td key={th} style={ isWeekend ? {
                              textAlign: "center",
                              padding: "0px",
                              fontSize: "14px",
                              border: "1px solid",
                              backgroundColor: "yellow"
                            } : isHoliday ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#0DBCBE"
                            } : {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM6.map(({th, isWeekend, isHoliday}) => (
                            <td key={th} style={ isWeekend ? {
                              textAlign: "center",
                              padding: "0px",
                              fontSize: "14px",
                              border: "1px solid",
                              backgroundColor: "yellow"
                            } : isHoliday ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#0DBCBE"
                            } : {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                      <td colSpan={32} style={{
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#FF9966"
                            }}>
                            ยอดรวมตั้งแต่เดือนตุลาคม - มีนาคม </td>
                        {dataListH.map(({th}) => (
                          <td key={th} style={{
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#FF9966"
                          }}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM7.map(({th, isWeekend, isHoliday}) => (
                          <td key={th} style={ isWeekend ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "yellow"
                          } : isHoliday ? {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid",
                          backgroundColor: "#0DBCBE"
                          } : {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM8.map(({th, isWeekend, isHoliday}) => (
                           <td key={th} style={ isWeekend ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "yellow"
                          } : isHoliday ? {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid",
                          backgroundColor: "#0DBCBE"
                          } : {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM9.map(({th, isWeekend, isHoliday}) => (
                           <td key={th} style={ isWeekend ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "yellow"
                          } : isHoliday ? {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid",
                          backgroundColor: "#0DBCBE"
                          } : {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM10.map(({th, isWeekend, isHoliday}) => (
                            <td key={th} style={ isWeekend ? {
                              textAlign: "center",
                              padding: "0px",
                              fontSize: "14px",
                              border: "1px solid",
                              backgroundColor: "yellow"
                            } : isHoliday ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#0DBCBE"
                            } : {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM11.map(({th, isWeekend, isHoliday}) => (
                           <td key={th} style={ isWeekend ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "yellow"
                          } : isHoliday ? {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid",
                          backgroundColor: "#0DBCBE"
                          } : {
                          textAlign: "center",
                          padding: "0px",
                          fontSize: "14px",
                          border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                        {dataListM12.map(({th, isWeekend, isHoliday}) => (
                            <td key={th} style={ isWeekend ? {
                              textAlign: "center",
                              padding: "0px",
                              fontSize: "14px",
                              border: "1px solid",
                              backgroundColor: "yellow"
                            } : isHoliday ? {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#0DBCBE"
                            } : {
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid"}}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                      <td colSpan={32} style={{
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#FF9966"
                            }}>
                            ยอดรวมตั้งแต่เดือนเมษายน - กันยายน </td>
                        {dataListH2.map(({th}) => (
                          <td key={th} style={{
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#FF9966"
                          }}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                      <td colSpan={32} style={{
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#FF9966"
                            }}>
                            ยอดรวมทั้งปี </td>
                        {dataListSumYear.map(({th}) => (
                          <td key={th} style={{
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid",
                            backgroundColor: "#FF9966"
                          }}>{th}</td>
                        ))}
                      </tr>
                      <tr>
                      <td colSpan={37} style={{
                            textAlign: "center",
                            padding: "0px",
                            fontSize: "14px",
                            border: "1px solid"
                            }}>
                            สีเหลือง = วันหยุดประจำสัปดาห์ (เสา - อาทิตย์) | สีฟ้า = วันหยุดนักขัตฤกษ์ (วันหยุดราชการ) |
                            ป = ลาป่วย | ก = ลากิจ | พ = พักผ่อน</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  </Col>
                </Grid>
              </CardBody>
            </Card>
          </Col>
        </Grid>   
      </div>
    );
}
export default LeaveInformation;